import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectUserTemplateList = createSelector(
  [(store: RootState) => store.userTemplate.userTemplateList],
  (data) => data
);
